import {Inject, Injectable} from '@angular/core';
import {GlobalConstants} from "../common/global-constants";
import {UrlUtils} from "./url.utils";
import {ConfigurationService} from "../services/configuration.service";
import {Mapping} from "../common/mapping";

@Injectable()
export class CommonUtils {

  defaultRegion: any;
  defaultArc: any;
  countryCodes: any;
  uploadBuckets: any;
  overridesBuckets: any;
  businessBuckets: any;
  removeLanesBuckets: any;

  constructor(@Inject('UrlUtils') private readonly urlUtils: UrlUtils, @Inject('ConfigurationService') private readonly configurationService: ConfigurationService) {
    configurationService.getSettings().subscribe(settings => {
      this.defaultRegion = settings.defaultRegion;
      this.defaultArc = settings.defaultArc;
      this.countryCodes = settings.countryCodes;
      this.uploadBuckets = settings.uploadBuckets;
      this.overridesBuckets = settings.overridesBuckets;
      this.businessBuckets = settings.businessBuckets;
      this.removeLanesBuckets = settings.removeLanesBuckets;
    });
  }

  getRegion() {
    return this.urlUtils.getSearchParam(location.href, GlobalConstants.URL_UTILS_REGION, this.defaultRegion);
  }

  getArc() {
    return this.urlUtils.getSearchParam(location.href, GlobalConstants.URL_UTILS_ARC, this.defaultArc);
  }

  getFromCountryCodes() {
    let countryCodes = this.countryCodes[this.getArc()][this.getRegion()];
    countryCodes.sort();
    return countryCodes;
  }

  getItemsBasedOnArc() {
    let items = [];
    if (this.getArc() == GlobalConstants.ARC_OOC) {
      items = Mapping.items_ooc;
    } else if (this.getArc() == GlobalConstants.ARC_DOM) {
      items = Mapping.items_domestic;
    }
    return items;
  }

  getItemsForTransitTimeOverrides() {
    let items = [];
    if (this.getArc() == GlobalConstants.ARC_DOM) {
      items = Mapping.items_transit_time_overrides;
    }
    return items;
  }

  getUploadBucket() {
    return this.uploadBuckets[this.getArc()][this.getRegion()];
  }

  getBusinessBucket() {
    return this.businessBuckets[this.getArc()][this.getRegion()];
  }

  getOverridesBucket() {
    return this.overridesBuckets[this.getArc()][this.getRegion()];
  }

  getRemoveLanesBucket() {
    return this.removeLanesBuckets[this.getArc()][this.getRegion()];
  }

  generateLookUpKeyColumns(record) {
    let currentWorkingRecordLookUpKeys = record[GlobalConstants.LOOK_UP_KEYS];
    let lookUpKeys = [];
    for (let lookUpKeyIndex in currentWorkingRecordLookUpKeys) {
      lookUpKeys.push(currentWorkingRecordLookUpKeys[lookUpKeyIndex][GlobalConstants.LOOK_UP_KEYS_KEY_NAME]);
    }
    let lookUpKeyColumns = {};
    lookUpKeyColumns[GlobalConstants.SINGLE_TRANSIT_TIME_COLUMNS] = lookUpKeys.concat(GlobalConstants.TRANSIT_TIME_COLUMN);
    lookUpKeyColumns[GlobalConstants.RANGE_TRANSIT_TIME_COLUMNS] = lookUpKeys.concat(GlobalConstants.MIN_MAX_TRANSIT_TIME_COLUMNS);
    return lookUpKeyColumns;
  }

  getDropDownOptions(currentWorkingRecord, transitTimeConfigurationRecords) {
    let dropDownOptions = {};
    let queryRecord = currentWorkingRecord;
    let filtered_records = transitTimeConfigurationRecords.filter(function (record) {
      return (record[GlobalConstants.BUSINESS_UNIT] == queryRecord[GlobalConstants.BUSINESS_UNIT]);
    });
    let componentKeyPlaceholderList = queryRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    for (let componentKeyPlaceholderIndex in componentKeyPlaceholderList) {
      dropDownOptions[componentKeyPlaceholderList[componentKeyPlaceholderIndex]] = new Set();
    }

    for (let recordIndex in filtered_records) {
      if (GlobalConstants.COMPONENT_KEY_VALUE in filtered_records[recordIndex]) {
        let filtered_record = filtered_records[recordIndex][GlobalConstants.COMPONENT_KEY_VALUE].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
        for (let index = 0; index < filtered_record.length; index++) {
          dropDownOptions[componentKeyPlaceholderList[index]].add(filtered_record[index])
        }
      }
    }

    for (let componentKeyPlaceholderIndex in componentKeyPlaceholderList) {
      let values = dropDownOptions[componentKeyPlaceholderList[componentKeyPlaceholderIndex]];
      dropDownOptions[componentKeyPlaceholderList[componentKeyPlaceholderIndex]] = Array.from(values);
      dropDownOptions[componentKeyPlaceholderList[componentKeyPlaceholderIndex]].sort();
    }
    return dropDownOptions;
  }

  getCurrentWorkingRecord(businessUseCase) {
    let currentWorkingRecord = {};
    let businessUseCaseList = businessUseCase.split(GlobalConstants.BUSINESS_USE_CASE_SEPARATOR);
    let businessUseCaseItem = this.getItemsBasedOnArc().filter(item => item.name == businessUseCaseList[0]);
    let businessUseCaseRecord = businessUseCaseItem[0][GlobalConstants.MAPPING_USE_CASES].filter(item => item.value == businessUseCase);
    currentWorkingRecord = businessUseCaseRecord[0][GlobalConstants.MAPPING];
    return currentWorkingRecord;
  }


  buildComponentKeyValue(componentKeyValue, componentKeyPlaceHolder) {
    let componentKeyValueObject = componentKeyValue;
    let componentKeyPlaceHolderList = componentKeyPlaceHolder.split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);

    let componentKeyValueList = [];
    for (let index in componentKeyPlaceHolderList) {
      componentKeyValueList.push(componentKeyValueObject[componentKeyPlaceHolderList[index]])
    }
    return componentKeyValueList.join(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
  }

  convertToDate(utcSeconds) {
    let currentDate = new Date(utcSeconds * 1000);
    const year = currentDate.getUTCFullYear();
    const date = currentDate.getUTCDate();
    const monthName = GlobalConstants.months[currentDate.getUTCMonth()];
    const dayName = GlobalConstants.days[currentDate.getUTCDay()];
    const hours = currentDate.getUTCHours();
    const minutes = currentDate.getUTCMinutes();
    const seconds = currentDate.getUTCSeconds();
    const formatted = `${dayName}, ${date} ${monthName} ${year}, ${hours}:${minutes}:${seconds}`;
    return formatted;
  }

  generateMetadata(obj) {
    return {
      'metadata': JSON.stringify(obj)
    }
  }

  isObject(value) {
    return (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value)
    );
  }
  

}
